import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';

/**
 * Browser/native Sentry boot, extracted from `App.tsx` (D70 FE3).
 *
 * - `VITE_ENABLE_SENTRY` is read defensively: a missing variable (an incomplete
 *   staging variable set) now disables Sentry instead of crashing boot.
 * - `environment` is explicit: `VITE_SENTRY_ENVIRONMENT`, defaulting to
 *   `production` so production's tag is unchanged when the variable is unset.
 */
export function initSentry(): void {
  if ((import.meta.env.VITE_ENABLE_SENTRY ?? '').toLowerCase() !== 'true') return;

  Sentry.init(
    {
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
      ],
      // Tracing
      tracesSampleRate: 1.0,
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/paire-wsr\.up\.railway\.app/],
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    },
    SentryReact.init
  );
}
